﻿'use strict';

export const toast = function (title, description, id, category_id, icon) {
    if (icon == undefined) {
        icon = "/img/favicon/notification.png";
    }
    var toastMessage =
        "<div class=\"toast\" data-id='" + id + "' role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">" +
        "<div class=\"toast-header\">" +
        "<img src=\"" + icon + "\" class=\"rounded mr-2\" alt=\"...\">" +
        "<strong class=\"mr-auto\">" +
        title +
        "</strong> " +
        //"<small class=\"text-muted\">Вчера</small>" +
        "<button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">" +
        "<span aria-hidden=\"true\" data-id=\"" + id + "\" class=\"toast-close\">&times;</span>" +
        "</button>" +
        "</div>" +
        "<div class=\"toast-body\">" +
        description +
        "</div>" +
        "</div>";
    $(".notification-inner").append(toastMessage);

    $('.toast[data-id=' + id + ']').toast({ animation: true, autohide: true, delay: 15000 });

    $(".toast[data-id=" + id + "]").toast("show");
};